var luxOrigin = "https://lux.speedcurve.com";
export function fromObject(obj) {
    var autoMode = getProperty(obj, "auto", true);
    return {
        auto: autoMode,
        beaconUrl: getProperty(obj, "beaconUrl", luxOrigin + "/lux/"),
        conversions: getProperty(obj, "conversions"),
        cookieDomain: getProperty(obj, "cookieDomain"),
        customerid: getProperty(obj, "customerid"),
        errorBeaconUrl: getProperty(obj, "errorBeaconUrl", luxOrigin + "/error/"),
        jspagelabel: getProperty(obj, "jspagelabel"),
        label: getProperty(obj, "label"),
        maxBeaconUrlLength: getProperty(obj, "maxBeaconUrlLength", 8190),
        maxBeaconUTEntries: getProperty(obj, "maxBeaconUTEntries", 20),
        maxErrors: getProperty(obj, "maxErrors", 5),
        maxMeasureTime: getProperty(obj, "maxMeasureTime", 60000),
        minMeasureTime: getProperty(obj, "minMeasureTime", 0),
        newBeaconOnPageShow: getProperty(obj, "newBeaconOnPageShow", false),
        samplerate: getProperty(obj, "samplerate", 100),
        sendBeaconOnPageHidden: getProperty(obj, "sendBeaconOnPageHidden", autoMode),
        serverTiming: getProperty(obj, "serverTiming"),
        trackErrors: getProperty(obj, "trackErrors", true),
        trackHiddenPages: getProperty(obj, "trackHiddenPages", false),
        pagegroups: getProperty(obj, "pagegroups"),
    };
}
export function getProperty(obj, key, defaultValue) {
    if (typeof obj[key] !== "undefined") {
        return obj[key];
    }
    return defaultValue;
}
